import React from 'react'
import { customFilter } from 'react-bootstrap-table2-filter'
import HeaderSearchBar from './HeaderSearchBar'
import { formatedDate } from '../../utils/formatedDate'
export let receiptNameFilter;
//let supplierNumberFilter;
let supplierNameFilter;
let storehouseCoordinatesOrNameFilter;

export function clearFilter() {
    receiptNameFilter(null)
    //supplierNumberFilter(null)
    supplierNameFilter(null)
    storehouseCoordinatesOrNameFilter(null)
}
export const columns = [
  {
    dataField: 'checkBox',
    text: '',
    sort: false,
    editable: false,
    headerClasses: 'checkBox-header-cell',
    classes: 'checkBox-cell'
  },
  {
    dataField: 'displayName',
    text: 'goodsReceiptsTable:receiptNo',
    sort: true,
    editable: false,
    filterKey: 'filter.receiptName',
    filter: customFilter(),
    filterRenderer: (onFilter, column) => <HeaderSearchBar onFilter={onFilter} column={column} getFilter={(filter) => { receiptNameFilter = filter }} />,
  },
  {
    dataField: 'supplier.displayName',
    text: 'goodsReceiptsTable:supplier',
    sort: true,
    editable: false,
    filterKey: 'filter.supplierName',
    filter: customFilter(),
    filterRenderer: (onFilter, column) => <HeaderSearchBar onFilter={onFilter} column={column} getFilter={(filter) => { supplierNameFilter = filter }} />,
    formatter: (cell, row, rowIndex, extraProps) => (
      <>
      {row.receiptType === "relocation" &&
        (<>
        <div>{row.sourceStorehouse.displayName}</div>
        <small>{row.sourceStorehouse.coordinateCode}</small>
        </>)
      }
      {row.receiptType !== "relocation" &&
        (<>
        <div>{row.supplier.displayName}</div>
        <small>{row.supplier.number}</small>
        </>)
      }
      </>
    ),
  },
  /*{
    dataField: 'supplier.number',
    text: 'goodsReceiptsTable:supplierNo',
    sort: true,
    editable: false,
    filterKey: 'filter.supplierNumber',
    filter: customFilter(),
    filterRenderer: (onFilter, column) => <HeaderSearchBar onFilter={onFilter} column={column} getFilter={(filter) => { supplierNumberFilter = filter }} />,
  },*/
  {
    dataField: 'positionCount.total',
    text: 'goodsReceiptsTable:positionCount',
    sort: true,
    editable: false,
    headerClasses: 'top-header-cell',
    /*formatter: (cell, row, rowIndex, extraProps) => (
        <>
          <div >
                {row.positionCount.total}{" ("}{row.positionCount.arrived}{"/"}{row.positionCount.stored}{")"}
          </div>
        </>
      ),*/
  },
  {
    dataField: 'expectedTimeOfArrival',
    text: 'goodsReceiptsTable:expectedTimeOfArrival',
    sort: true,
    editable: false,
    headerClasses: 'top-header-cell',
    formatter: (cell, row) => (formatedDate(cell))
  },
  {
    dataField: 'targetStorehouse.displayName',
    text: 'goodsReceiptsTable:warehouse',
    sort: true,
    editable: false,
    filterKey: 'filter.storehouseCoordinatesOrName',
    filter: customFilter(),
    filterRenderer: (onFilter, column) => <HeaderSearchBar onFilter={onFilter} column={column} getFilter={(filter) => { storehouseCoordinatesOrNameFilter = filter }} />,
    formatter: (cell, row, rowIndex, extraProps) => (
      <>
        <div>{row.targetStorehouse.displayName}</div>
        <small>{row.targetStorehouse.coordinateCode}</small>
      </>
    ),
  },
  {
    dataField: 'receiptType',
    text: 'goodsReceiptsTable:receiptType',
    sort: true,
    editable: false,
    headerClasses: 'top-header-cell',
  },
  {
    dataField: 'actions',
    text: '',
    headerClasses: 'actions-header-cell',
    classes: 'actions-cell'
  }
];
